import type { DailySchedulePlan } from './types';

export const DAILY_SCHEDULE_DRAFT_VERSION = 1 as const;

export interface DailyScheduleDraft {
  version: typeof DAILY_SCHEDULE_DRAFT_VERSION;
  scheduleDate: string;
  savedAt: string;
  plan: DailySchedulePlan;
}

export function draftStorageKey(userId: string, scheduleDate: string): string {
  return `ubus.ds.draft.${userId}.${scheduleDate}`;
}

export function serializeDailyScheduleDraft(input: {
  scheduleDate: string;
  savedAt: string;
  plan: DailySchedulePlan;
}): string {
  const draft: DailyScheduleDraft = {
    version: DAILY_SCHEDULE_DRAFT_VERSION,
    scheduleDate: input.scheduleDate,
    savedAt: input.savedAt,
    plan: input.plan,
  };
  return JSON.stringify(draft);
}

export function parseDailyScheduleDraft(raw: string): DailyScheduleDraft | null {
  try {
    const data = JSON.parse(raw) as unknown;
    if (!data || typeof data !== 'object') return null;
    const obj = data as Record<string, unknown>;
    if (obj.version !== DAILY_SCHEDULE_DRAFT_VERSION) return null;
    if (typeof obj.scheduleDate !== 'string' || !obj.scheduleDate) return null;
    if (typeof obj.savedAt !== 'string' || !obj.savedAt) return null;
    if (!obj.plan || typeof obj.plan !== 'object') return null;
    const plan = obj.plan as DailySchedulePlan;
    if (!Array.isArray(plan.vehicles) || !Array.isArray(plan.unassignedJobIds)) return null;
    return {
      version: DAILY_SCHEDULE_DRAFT_VERSION,
      scheduleDate: obj.scheduleDate,
      savedAt: obj.savedAt,
      plan,
    };
  } catch {
    return null;
  }
}
